import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

export const hotelAutoCompleteIconMap = {
  country: LocationOnOutlinedIcon,
  city: LocationCityOutlinedIcon,
  airport: FlightTakeoffOutlinedIcon,
  district: MapOutlinedIcon,
  hotel: HotelOutlinedIcon,
};

export const getHotelIconName = (type: keyof typeof hotelAutoCompleteIconMap) => {
  return hotelAutoCompleteIconMap[type] || MapOutlinedIcon;
};
